import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as mFooterActions from '../actions/mFooterActions';
import MListNav from './MListNav';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {SiteSearch} from './SiteSearch';
import {withRouter} from '../withRouterCompat';


class MFooter extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      searchQuery: '',
      searchBusy: false,
    };
    this.debouncedDoSearch = helpers.debounceEvent((query) => {
      Promise.resolve(this.props.actions.doSearch(query, this.props.mFooter && this.props.mFooter.id))
        .then(() => {
          if(this.state.searchQuery === query){
            this.setState({searchBusy: false});
          }
        })
        .catch(() => {
          if(this.state.searchQuery === query){
            this.setState({searchBusy: false});
          }
        });
    }, 300);
  }
  componentDidMount(){
    //console.log(`MFooter.componentDidMount()`, this.props);
    this.props.actions.initMFooter();
  }
  componentWillUnmount(){
    this.debouncedDoSearch.cancel();
  }


  input_onChange = event => {
    const value = event.target.value;
    const isSearchOpen = value.length > 0;
    if(Boolean(this.props.mFooter?.isSearchOpen) !== isSearchOpen){
      this.props.actions.toggleSearch(isSearchOpen, this.props.mFooter && this.props.mFooter.id);
    }
    this.setState({
      searchQuery: value,
      searchBusy: Boolean(value),
    });
    this.handleSearch(value);
  };
  on_Submit = () => {
    this.props.history.push('/projects');
  };
  searchClear_onClick = () => {
    this.setState({searchQuery: '', searchBusy: false});
    setTimeout(() => {
      this.props.actions.toggleSearch(false, this.props.mFooter && this.props.mFooter.id);
    });
  };
  siteSearch_onBlur = () => {
    const footerId = this.props.mFooter && this.props.mFooter.id;
    this.props.actions.toggleSearch(false, footerId);
  };
  siteSearch_onFocus = () => {
    const footerId = this.props.mFooter && this.props.mFooter.id;
    this.props.actions.toggleSearch(true, footerId);
  };


  handleSearch = query => {
    if(!query){
      this.debouncedDoSearch.cancel();
      this.setState({searchBusy: false});
      this.props.actions.doSearch('', this.props.mFooter && this.props.mFooter.id);
      return;
    }
    this.debouncedDoSearch(query);
  };

  renderFooterListNav(nav, className) {
    if (!nav || !nav.id) return null;
    const props = {
      className,
      key: nav.id,
    };
    if (nav.navigationLinks && nav.navigationLinks.length) {
      return <MListNav {...props} mListNav={nav} />;
    }
    return <MListNav {...props} cmsId={nav.id} />;
  }

  renderContactDescription(){
    if(!this.props.mFooter.contactText) return null;

    return (
      <div className="m-footer__contact-description">
        {helpers.nToP(this.props.mFooter.contactText)}
      </div>
    );
  }
  renderFeaturedProjects(){
    if(this.props.mFooter.suggestedProjects) return null;

    return (
      <div className="col-12">
        <MListNav cmsName={apiValues.NAV_FEATURED_PROJECTS} className="m-listnav--page-search-results"/>
      </div>
    );
  }
  renderMobileContactLinks(){
    if(!this.props.mFooter.mobileContactLinks || !this.props.mFooter.mobileContactLinks.id) return null;

    return (
      <div className="col-12 d-md-none">
        <hr className="d-md-none hr--white-light"/>
        <MListNav className="m-listnav--footer" key={this.props.mFooter.mobileContactLinks.id} cmsId={this.props.mFooter.mobileContactLinks.id}/>
      </div>
    );
  }
  renderMobileLinks(){
    if(!this.props.mFooter.mobileLinks || !this.props.mFooter.mobileLinks.id) return null;

    return (
      <div className="col-12 d-md-none">
        <MListNav className="m-listnav--footer" key={this.props.mFooter.mobileLinks.id} cmsId={this.props.mFooter.mobileLinks.id}/>
      </div>
    );
  }
  renderSiteSearch(){
    if(!this.props.mFooter.socialList || !this.props.mFooter.socialList.id) return null;

    return (<div className="col-12 col-md-5">
        {/* <SiteSearch className="m-footer__site-search"/> */}
        <SiteSearch className={`m-footer__site-search`}
                    inputAriaLabel="Search projects (footer)"
                    inputID="footer-search"
                    isOpen={this.props.mFooter.isSearchOpen}
                    onBlur={this.siteSearch_onBlur}
                    onClearClick={this.searchClear_onClick}
                    onFocus={this.siteSearch_onFocus}
                    onInputChange={this.input_onChange}
                    onSubmit={this.on_Submit}
                    isLoading={this.state.searchBusy}
                    inputPlaceholder="Search our projects">
          <div className="row">
            {this.renderFeaturedProjects()}
            {this.renderSuggestedProjects()}
          </div>
        </SiteSearch>
        <hr className="hr--white-light d-none d-md-block"/>
        {this.renderFooterListNav(
          this.props.mFooter.socialList,
          'm-listnav--footer m-listnav--footer-social m-listnav--horizontal'
        )}
      </div>
    );
  }
  renderSubmenuA(){
    if(!this.props.mFooter.submenuA || !this.props.mFooter.submenuA.id) return null;

    return (<div className="col-12 col-md-2 d-none d-md-block">
        {this.renderFooterListNav(this.props.mFooter.submenuA, 'm-listnav--footer')}
      </div>
    );
  }
  renderSubmenuB(){
    if(!this.props.mFooter.submenuB || !this.props.mFooter.submenuB.id) return null;

    return (<div className="col-12 col-md-2 d-none d-md-block">
        {this.renderFooterListNav(this.props.mFooter.submenuB, 'm-listnav--footer')}
      </div>
    );
  }
  renderSubmenuC(){
    if(!this.props.mFooter.submenuC || !this.props.mFooter.submenuC.id) return null;

    return (
      <div className="col-12 col-md-3 d-none d-md-block">
        {this.renderFooterListNav(this.props.mFooter.submenuC, 'm-listnav--footer')}
        {this.renderContactDescription()}
      </div>
    );
  }
  renderSuggestedProjects(){
    if(!this.props.mFooter.suggestedProjects) return null;

    let mListNav = {
      title: 'Suggested Projects',
      navigationLinks: this.props.mFooter.suggestedProjects.slice(0, 4).map(project => {
        return {
          key: project.id,
          title: project.title,
          url: `/projects/${project.slug ? project.slug : ''}`,
        };
      }),
      highlight: this.state.searchQuery,
    };

    return (
      <div className="col-12">
        <MListNav mListNav={mListNav} className="m-listnav--page-search-results"/>
        <SuperLink to={`${this.state.searchQuery && this.state.searchQuery !== '' ? '/projects?Title_contains=' + this.state.searchQuery : '/projects'}`} className="m-projectlistmap__results-link">View all projects for <q>{this.state.searchQuery}</q></SuperLink>
      </div>
    );
  }
  render(){
    //console.log(`MFooter.render()`, this.props);

    if(!this.props.mFooter) return (
      <footer className={`m-footer ${this.props.className || ''}`}>
        <div className="is-loading">loading...</div>
      </footer>
    );
    else {
      return (
      <footer className={`m-footer ${this.props.className || ''}`}>
        <div className="container-fluid container--coupling">
          <div className="row m-footer__row-top">
            {this.renderSubmenuA()}
            {this.renderSubmenuB()}
            {this.renderSubmenuC()}
            {this.renderMobileLinks()}
            {this.renderMobileContactLinks()}
            {this.renderSiteSearch()}
          </div>
          <hr className="hr--white-light"/>
          <div className="row">
            <div className="col-12 col-lg-6">
              <span className="m-footer__bot-left-text">{this.props.mFooter.botLeftText}</span>
            </div>
            <div className="col-12 col-lg-6 m-footer__legal-text-col">
              <span className="m-footer__legal-text">{this.props.mFooter.legalText}</span>
            </div>
          </div>
        </div>
      </footer>
      );
    }
  }
}


export default withRouter(connect(
  (state, ownProps) => ({
    mFooter: ownProps.cmsId
      ? helpers.getById(state.mFooter, ownProps.cmsId)
      : helpers.getLoadedModule(state.mFooter),
  }),
  (dispatch) => ({
    actions: bindActionCreators(mFooterActions, dispatch),
  }),
)(MFooter));


MFooter.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  history: PropTypes.object,
  mFooter: PropTypes.object,
};
